import { Circle } from "lucide-react";
import React from 'react';

import './match-rating.css';

/**
 * MatchRating Component
 *
 * @param {Object} props
 * @param {number} props.rating - Rating value from 1 to 5
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.rest - Additional props passed to the container div
 */
const MatchRating = ({
    rating = 0,
    className = '',
    ...rest
}) => {
    // Ensure rating is between 0 and 5
    const normalizedRating = Math.max(0, Math.min(5, Math.round(rating)));

    return (
        <div className={`flex items-center gap-0.5 text-body leading-none ${className}`} {...rest}>
            {/* Filled dots for the rating */}
            {[...Array(normalizedRating)].map((_, index) => (
                <span key={`filled-${index}`}>
                    <Circle size="1em" fill="currentColor" className="match-rating-filled" />
                </span>
            ))}

            {/* Empty dots for remaining spots */}
            {[...Array(5 - normalizedRating)].map((_, index) => (
                <span key={`empty-${index}`}>
                    <Circle size="1em" className="match-rating-empty" />
                </span>
            ))}
        </div>
    );
};

export default MatchRating;
